import { render, staticRenderFns } from "./menu1.vue?vue&type=template&id=30298bf1&scoped=true"
import script from "./menu1.vue?vue&type=script&lang=js"
export * from "./menu1.vue?vue&type=script&lang=js"
import style0 from "./menu1.vue?vue&type=style&index=0&id=30298bf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30298bf1",
  null
  
)

export default component.exports